import styled from 'styled-components';

const QuoteContainer = styled.div``;

export { QuoteContainer };
